import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';
import { fetchAndActivate } from 'firebase/remote-config';
import { getValue } from 'firebase/remote-config';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RemoteConfigService {
  private remoteConfig: any;

  constructor() {
    const app = initializeApp(environment.firebaseConfig);
    this.remoteConfig = getRemoteConfig(app);
    this.remoteConfig.settings.minimumFetchIntervalMillis = 3600000; //Fetch every hour
  }

  get envName(): string {
    return environment.name ?? 'dev';
  }

  async fetchAndGetValue(key: string): Promise<string> {
    await fetchAndActivate(this.remoteConfig);
    return getValue(this.remoteConfig, key).asString();
  }
}
